import { SettingSource, SettingStore } from '../SettingStore';
import { loadModuleDirectly } from '../../../../@Util/DependencyInjection/Injection/DependencyInjection';

export default function getSetting<T>(type: SettingSource, code: string): T
{
    return loadModuleDirectly(SettingStore).getValue(type, code);
}
